import { render, staticRenderFns } from "./requestPasswordReset.vue?vue&type=template&id=f350f1d8&scoped=true"
import script from "./requestPasswordReset.vue?vue&type=script&lang=js"
export * from "./requestPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./requestPasswordReset.vue?vue&type=style&index=0&id=f350f1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f350f1d8",
  null
  
)

export default component.exports